
import http from "../http-common";
import AppStorageService from "./app-storage.service";

class AuthService {

  // User login
  login(user) {
    return http
      .post(`/login/`, {
        username: user.username,
        password: user.password
      })
      .then(response => {
        if (response.data.accessToken) {
          AppStorageService.setUser(response.data);
        }
        return response.data;
      });
  }

  // User logout
  logout() {
    AppStorageService.clearSession();
  }

}

export default new AuthService();
